/** FAQ visible on web (excludes mobile-only and telegram-only). */
export function faqVisibleOnWeb(item) {
  return !item?.mobileOnly && !item?.telegramOnly;
}

/** FAQ visible on mobile (excludes web-only and telegram-only). */
export function faqVisibleOnMobile(item) {
  return !item?.webOnly && !item?.telegramOnly;
}

/** FAQ visible in Telegram bot (telegram-only flag). */
export function faqVisibleOnTelegram(item) {
  return item?.telegramOnly === true;
}
